export default "__VITE_ASSET__C8GMXa98__"